<template>
  <v-app>
    <slot />

    <snackbar :show="show"></snackbar>
  </v-app>
</template>

<script setup>
useHead({
  meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' }]
})

import snackbar from '@/layouts/imports/snackbar'
import { useTheme } from 'vuetify'

const theme = useTheme()
const pimTheme = useCookie('pim_theme')

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - Starielle` : 'Inventory Starielle'
  }
})

const { show } = useSnackbarStore()

// data

// method
theme.global.name.value = pimTheme.value || 'light'
</script>
